import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getCodigosPostales,
  updateCodigoPostal,
  insertCodigoPostal,
  deleteCodigoPostal,
  getTiposCodigosPostales,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_CODIGOS_POSTALES(action) {
  try {
    const cpsData = yield call(getCodigosPostales, action.payload)
    if (cpsData.ok) {
      yield put({
        type: actions.CPS_LOAD_SUCCEEDED,
        payload: cpsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Códigos Postales')
      put({
        type: actions.CPS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CPS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_TIPOS_CODIGOS_POSTALES() {
  try {
    const tiposData = yield call(getTiposCodigosPostales)
    if (tiposData.ok) {
      yield put({
        type: actions.CP_TIPOS_LOAD_SUCCEEDED,
        payload: tiposData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Tipos Códigos Postales')
      put({
        type: actions.CP_TIPOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CP_TIPOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CODIGO_POSTAL(action) {
  try {
    const cpObj = yield call(insertCodigoPostal, action.payload)
    if (cpObj.ok) {
      putMessage(messageType.SUCCESS, 'Código Postal creado correctamente')
      yield put({
        type: actions.CP_INSERT_SUCCEEDED,
        payload: cpObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Código Postal')
      yield put({
        type: actions.CP_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Código Postal')
    yield all([
      put({
        type: actions.CP_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CODIGO_POSTAL(action) {
  try {
    const cpObj = yield call(updateCodigoPostal, action.payload)
    if (cpObj.ok) {
      putMessage(messageType.SUCCESS, 'Código Postal modificado correctamente')
      yield put({
        type: actions.CP_UPDATE_SUCCEEDED,
        payload: cpObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Código Postal')
      yield put({
        type: actions.CP_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Código Postal')
    yield all([
      put({
        type: actions.CP_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CODIGO_POSTAL(action) {
  try {
    const cpResult = yield call(deleteCodigoPostal, action.payload)
    if (cpResult.ok) {
      putMessage(messageType.SUCCESS, 'Código Postal eliminado correctamente')
      yield put({
        type: actions.CP_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Código Postal')
      yield put({
        type: actions.CP_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Código Postal')
    yield all([
      put({
        type: actions.CP_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CPS_LOAD_REQUESTED, GET_CODIGOS_POSTALES),
    takeEvery(actions.CP_TIPOS_LOAD_REQUESTED, GET_TIPOS_CODIGOS_POSTALES),
    takeEvery(actions.CP_INSERT_REQUESTED, INSERT_CODIGO_POSTAL),
    takeEvery(actions.CP_UPDATE_REQUESTED, UPDATE_CODIGO_POSTAL),
    takeEvery(actions.CP_DELETE_REQUESTED, DELETE_CODIGO_POSTAL),
  ])
}
